module.exports = __webpack_public_path__ + "01_very_short_yellow.0cd0adf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_very_short_yellow.png
// module id = G/46
// module chunks = 0